interface ErrorResponse {
  statusCode: number;
  timestamp: string;
  path: string;
  method: string;
  message: string;
  error: string;
  referenceId?: string;
}

const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_BASE_URL;
  }
  // In development, we use a proxy, so we can use relative paths
  return '';
}

const api = async (url: string, options: RequestInit = {}) => {
  const baseUrl = getApiBaseUrl();

  const headers = new Headers(options.headers);

  if (!(options.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(`${baseUrl}${url}`, {
    ...options,
    headers,
    credentials: 'include', // Include cookies in requests for session authentication
  });

  if (!response.ok) {
    const errorData: ErrorResponse = await response.json().catch(() => ({
      statusCode: response.status,
      message: 'An error occurred',
      error: 'Unknown Error',
    }));

    // Create a more informative error message
    let errorMessage = errorData.message || 'An error occurred';
    
    // Add reference ID to the message for internal server errors
    if (errorData.referenceId && errorData.statusCode >= 500) {
      errorMessage = `${errorMessage}\n\nReference ID: ${errorData.referenceId}\nPlease include this ID when reporting this issue.`;
    }

    const error = new Error(errorMessage);
    (error as any).statusCode = errorData.statusCode;
    (error as any).referenceId = errorData.referenceId;
    (error as any).originalError = errorData;
    
    throw error;
  }

  if (response.status === 204) {
    return;
  }
  
  return response.json();
};

export default api;
